import React from 'react';
import useTranslate from '~/hooks/useTranslate';
import useModals from '~/hooks/useModals';
import TermsAndConditionsModal from '~/components/shared/Terms/TermsAndConditionsModal';
import { TextHeader } from '~/components/shared/Terms/styledComponents';
import { useSelector } from 'react-redux';
import { RootState } from '~/store/types/sharedTypes';

const useTermAndConditionModal = () => {
  const t = useTranslate();
  const modals = useModals();
  const { matchedMedia } = useSelector((state: RootState) => state);
  const openTermAndConditionModal = () => {
    modals.openModal({
      header: (
        <TextHeader>
          {t('TermsAndConfirmationCard.UserAgreementPopupHeader') as string}
        </TextHeader>
      ),
      children: <TermsAndConditionsModal />,
      size: 'xl',
      fullScreen: matchedMedia.smallScreenPortrait,
      filledBackground: true,
    });
  };

  return {
    openTermAndConditionModal,
  };
};

export default useTermAndConditionModal;
